<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="12" offset="10">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                             :size="GCONFIG.styleElFormSize">
                        <el-form-item label="促销员">
                            <el-input v-model="formInline.salePersonName" placeholder="促销员姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <el-input v-model="formInline.salePersonMobile" placeholder="促销员手机号"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="mini" @click="getList">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip class="item" effect="dark" content="新增" placement="right">
                                <el-button type="success" size="mini" @click="handleAdd">新增</el-button>
                            </el-tooltip>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>

        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="salePersonName" label="促销员" width="200"></el-table-column>
            <el-table-column prop="salePersonMobile" label="手机号"></el-table-column>
            <!--<el-table-column prop="shopName" label="连接类型"></el-table-column>-->
            <el-table-column prop="status" label="状态" width="150">
                <template slot-scope="scope">
                    <span>{{scope.row.status == 1 ? '启用' : '未启用'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="150">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                    <el-button type="warning" size="mini" @click="handleDel(scope.row)">{{scope.row.status == 1 ? '禁用' : '启用'}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--<div class="pagination-wrap">-->
            <!--<el-pagination-->
                    <!--background-->
                    <!--@size-change="handleSizeChange"-->
                    <!--@current-change="handleCurrentChange"-->
                    <!--:current-page="formInline.currentPage"-->
                    <!--:page-sizes="GCONFIG.pageSizes"-->
                    <!--:page-size="formInline.pageSize"-->
                    <!--layout="total, sizes, prev, pager, next, jumper"-->
                    <!--:total="formInline.recordsTotal">-->
            <!--</el-pagination>-->
        <!--</div>-->
        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.salePersonId></el-input>
                </el-form-item>
                <el-form-item label="促销员" :required="true">
                    <el-input v-model=form.salePersonName></el-input>
                </el-form-item>
                <el-form-item label="电话" :required="true">
                    <el-input v-model=form.salePersonMobile></el-input>
                </el-form-item>
                <!--<el-form-item label="门店系统" :hidden="true">-->
                    <!--<el-select v-model="form.shopTypeName" placeholder="门店系统">-->
                        <!--<el-option v-for="item in shopTypeNameList"-->
                                   <!--:key="item.id"-->
                                   <!--:label="item.name"-->
                                   <!--:value="item.id">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->

                <el-form-item label="启用状态" :required="true">
                    <el-select v-model="form.status" placeholder="启用状态">
                        <el-option v-for="item in defaultConfigData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button-group>
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="save(form)">确 定</el-button>
                    </el-button-group>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getSalePersionList,
        saveSalePersion,
        deleteShopSalePersion
    } from '../../api/api';
    import uploadComponents from '@/components/upload';
    import picDialog from '@/components/pic_dialog/pic_list'
    import Preview from "../../components/Preview";
    //定义组件
    export default{
        data(){
            return {
                listData: [],
                defaultConfigData: [{"id": 0, "name": "否"}, {"id": 1, "name": "是"}],
                loading: true,
                dialogFormVisible: false,
                shopTypeNameList:[],
                cityNameList:[{"id": "北京", "name": "北京"}, {"id": "天津", "name": "天津"}, {"id": "济南", "name": "济南"},
                    {"id": "沈阳", "name": "沈阳"}, {"id": "大连", "name": "大连"}, {"id": "青岛", "name": "青岛"},
                    {"id": "石家庄", "name": "石家庄"}, {"id": "廊坊", "name": "廊坊"}, {"id": "长沙", "name": "长沙"},
                    {"id": "武汉", "name": "武汉"}, {"id": "成都", "name": "成都"}, {"id": "上海", "name": "上海"},
                    {"id": "杭州", "name": "杭州"}, {"id": "贵阳", "name": "贵阳"}, {"id": "深圳", "name": "深圳"},
                    {"id": "昆明", "name": "昆明"}, {"id": "南宁", "name": "南宁"}, {"id": "广州", "name": "广州"}],
                form: {
                    salePersonId: '',
                    salePersonName: '',
                    salePersonMobile: '',
                    shopId: '',
                    status: 1
                },
                formInline: {
                    salePersonName: '',
                    salePersonMobile: '',
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0
                }
            }
        },
        computed: {
            productList: function () {
                return this.$store.getters.getPro.list
            },
            totalRecord: function () {
                return this.$store.getters.getPro.total
            },
            productTypes: function () {
                return this.$store.getters.getProductType
            }
        },
        //挂载时候执行
        mounted(){
            this.getList();
        },
        components: {
            uploadComponents, picDialog
        },
        methods: {
            //定义查询方法
            getList(){
                getSalePersionList(this.formInline).then((res) => {
                    this.loading = false;
//                    this.formInline.recordsTotal = res.data.value.total;
                    this.listData = res.data.value;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleDel(row){
                //if (confirm("删除:" + row.salePersonName + ",确定删除:" + row.salePersonName + "吗？")) {
                    deleteShopSalePersion({salePersonId: row.salePersonId}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
//                }
            },
            handleAdd(){
                this.dialogFormVisible = true;
                this.form = {
                    salePersonId: '',
                    salePersonName: '',
                    salePersonMobile: '',
                    shopId: '',
                    status: 1
                }
            },
            handlePreActive(row){
                if (row.pathType ==5) {
                    this.params = {bindCode: row.bindCode, activeNo: row.activeNo};
                } else {
                    this.params = {productId: row.itemId, productType: row.pathType};
                }
                this.showPreviewDialog = true;
            },
            handleEdit(data){
                this.dialogFormVisible = true;
                this.form = {
                    salePersonId: data.salePersonId,
                    salePersonName: data.salePersonName,
                    salePersonMobile: data.salePersonMobile,
                    shopId: data.shopId,
                    status: data.status
                }
            },
            save(data){
                console.log(data);
                if (data.salePersonName == "") {
                    this.$message({
                        message: "请输入促销员姓名",
                        type: 'error'
                    });
                    return;
                }
                if (data.salePersonMobile == "") {
                    this.$message({
                        message: "请输入促销员电话",
                        type: 'error'
                    });
                    return;
                }
                saveSalePersion(data).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },

            returnHistory(){
                window.history.back()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/distribution/salePersonInfo.vue